/* eslint-disable no-unused-vars */
/**
 * Turn an email shortcode into a link.
 * @param {string} user username part of the email
 * @param {string} domain domain part of the email
 * @param {string} className any class name to set
 * @param {string} content the displayed text for the link
 * @param {string} dataAttributes any data attributes to set
 * @param {string} htmlId any ID to set
 * @param {string} wrapper class name of the container where the link needs to be appended
 * @returns {undefined}
 */
function createEmailComponent(user, domain, className, content, dataAttributes, htmlId, wrapper) {
    const emailAddress = user + "@" + domain;
    const emailObject = {
        href: "mailto:" + emailAddress,
        content: content,
        htmlId: htmlId,
        className: className,
        dataAttributes: dataAttributes
    };
    const wrapperId = "emailComponent" + wrapper;
    const emailComponentWrapper = document.getElementById(wrapperId);

    if (emailComponentWrapper) {
        const emailLink = createAnchorTag(emailObject);
        emailComponentWrapper.replaceChildren(emailLink);
    }
}

/**
 * Create an anchor element
 * @param {object} emailObject Object containing email informations
 * @returns {Element} A <a> html element
 */
function createAnchorTag(emailObject) {
    const emailLink = document.createElement('a');
    emailLink.setAttribute('href', emailObject.href);

    if (emailObject.htmlId) {
        emailLink.setAttribute('id', emailObject.htmlId);
    }

    if (emailObject.className) {
        emailLink.setAttribute('class', emailObject.className);
    }

    setDataAttributes(emailLink, emailObject.dataAttributes);
    setContent(emailLink, emailObject.content);

    return emailLink;
}

/**
 * Parse and add data attributes to the link
 * @param {Element} element The link tag we want to apply attributes to
 * @param {array} dataAttributes List of data attributes
 * @returns {undefined}
 */
function setDataAttributes(element, dataAttributes) {
    if (dataAttributes) {
        let dataAttributeItems = dataAttributes.split('|');
        dataAttributeItems.forEach(item => {
            let [dataAttributeKey, dataAttributeValue] = item.split('=');
            let cleanedAttributeKey = dataAttributeKey.trim();
            let cleanedAttributeValue = dataAttributeValue.replace(/"/g, '');
            element.setAttribute(cleanedAttributeKey, cleanedAttributeValue);
        });
    }
}

/**
 * Apply the content as the label of the link
 * @param {Element} element The HTML element to get the content
 * @param {string} content The string used as the label's link
 * @returns {undefined}
 */
function setContent(element, content) {
    const parser = new DOMParser();
    let parsedContent = parser.parseFromString(content, "text/html");
    element.append(parsedContent.body.firstChild);
}

/**
 * Make the component available for Interactive Documentation
 * @returns {void}
 */
function activateEmailInteractiveDocumentation() {
    // Handle wrapper element
    const spanSelector = 'span[id^="emailComponent"]';
    let wrapperElement = document.querySelector(spanSelector);

    // If span is not found, we'll use MutationObserver to check for ajax updates
    if (!wrapperElement) {
        const observer = new MutationObserver((mutations, obs) => {
            mutations.forEach(() => {
                const addedWrapper = document.querySelector(spanSelector);
                if (addedWrapper) {
                    wrapperElement = addedWrapper;
                    obs.disconnect();
                    finalizeWrapper(wrapperElement);
                }
            });
        });

        // Start observing the DOM
        const targetNode = document.querySelector('.post-content');
        observer.observe(targetNode, { childList: true, subtree: true });
    } else {
        finalizeWrapper(wrapperElement);
    }

    /**
     * Initialize the Email component by its wrapper element
     *
     * @param {HTMLElement} wrapperElement corresponds to the <span id="emailComponent{{wrapper}}"></span> in the view
     * @returns {void}
     */
    function finalizeWrapper(wrapperElement) {
        // Retrieve values from input fields
        const classInput = document.querySelector('input.bocss-input__text[name="class"]');
        const contentInput = document.querySelector('input.bocss-input__text[name="content"]');
        const dataAttributeInput = document.querySelector('input.bocss-input__text[name="data_attribute"]');
        const htmlIdInput = document.querySelector('input.bocss-input__text[name="html_id"]');
        const emailInput = document.querySelector('input.bocss-input__text[name="email"]');

        const classValue = classInput ? classInput.value : '';
        const contentValue = contentInput ? contentInput.value : '';
        const dataAttributeValue = dataAttributeInput ? dataAttributeInput.value : '';
        const htmlIdValue = htmlIdInput ? htmlIdInput.value : '';

        // Handle email input value
        let user = 'test';
        let domain = 'test.ca';

        if (emailInput && emailInput.value.includes('@')) {
            [user, domain] = emailInput.value.split('@');
        }

        const wrapperId = wrapperElement
            ? wrapperElement.getAttribute('id').substring('emailComponent'.length)
            : 'test';

        createEmailComponent(user, domain, classValue, contentValue, dataAttributeValue, htmlIdValue, wrapperId);
    }
}
